import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { SurveyService } from '../../Services/survey.service';
import { ActivatedRoute } from '@angular/router';
import { Survey, SurveyQuestion } from '../../Models/Survey';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { SurveyQuestionComponent } from 'src/app/survey/Components/survey-question/survey-question.component';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { VERBIAGE } from 'src/app/config';

@Component({
    selector: 'survey-edit',
    templateUrl: './survey-edit.component.html',
    styleUrls: ['./survey-edit.component.scss'],
})

export class SurveyEditComponent implements OnInit {
    Survey: Survey;
    SurveyQuestions: SurveyQuestion[];

    constructor(
        private _shared: SharedService, private _route: ActivatedRoute, private _survey: SurveyService,
        private _notify: NotificationService
    ) {
        // Setting up page title
        this._shared.pageTitle = 'Edit Survey Questionaire'

        // Show loader
        this._shared.loadingState = true;
    }

    async ngOnInit() {
        const SurveyID = +this._route.snapshot.params.id;
        this.Survey = await this._survey.getSurveyByID(SurveyID);
        this.SurveyQuestions = (await this._survey.getSurveyQuestions(this.Survey.SurveyID))['SurveyQuestionModel'];

        this._shared.loadingState = false;
    }

    addQuestion() {
        let ref = this._shared.openModal(SurveyQuestionComponent, {});
        ref.afterClosed().subscribe(async (res: SurveyQuestion) => {
            if (!res) { return; }

            res.SurveyID = this.Survey.SurveyID;
            res.CreatedBy = 1;

            let result = await this._survey.postSurveyQuestion(res);
            if (result['status'] === 'OK') {
                res.SurveyQuestionID = result['QuestionID'];
                this.SurveyQuestions.push(res);
            }
        })
    }

    deleteQuestion(SurveyQuestionID: number) {
        const _this = this;
        this._notify.openDialog({
            title: VERBIAGE.SURVEY_DELETE_QUESTION_TITLE, body: VERBIAGE.SURVEY_DELETE_QUESTION_BODY,
            handlers: [
                { color: 'warn', type: '-raised-', text: 'Confirm', action() {
                    // Delete from DB
                    _this._survey.deleteSurveyQuestion(SurveyQuestionID).subscribe(res => {
                        if (res['status'] === 'OK') {
                            let index = _this.SurveyQuestions.findIndex(q => q.SurveyQuestionID === SurveyQuestionID);
                            _this.SurveyQuestions.splice(index, 1);
                        }
                    })
                }}, { type: '-raised-', text: 'Cancel' }
            ]
        })
    }

    updateQuestionOrder(e) {
        moveItemInArray(e.container.data, e.previousIndex, e.currentIndex);
        this.Survey.ModifiedBy = 1;
        this.Survey.ModifiedDate = this._survey.dateParse(new Date().toISOString());
        this.Survey.SurveyQuestionModel = this.SurveyQuestions;

        this._survey.updateQuestionOrder(this.Survey.SurveyQuestionModel).subscribe(res => {
            // Process response here
        });
    }
}